import classNames from "classnames";

import VehiclePointIcon from "assets/icons/vehicle-point.svg";
import VehicleIcon from "assets/icons/vehicle.svg";

import styles from "./map-vehicle-marker-icon.module.scss";

interface MapVehicleMarkerIconInterface {
  isInPoint: boolean;
  index: string;
}

const MapVehicleMarkerIcon = ({
  isInPoint,
  index
}: MapVehicleMarkerIconInterface) => {
  return (
    <div className={styles["marker"]} data-testid="vehicle-marker">
      <span className={styles["title"]}>#{index}</span>
      <img
        className={classNames(styles["point"], {
          [styles["point-out"]]: !isInPoint
        })}
        src={VehiclePointIcon}
        alt="point-icon"
      />
      {isInPoint && (
        <img
          className={styles["vehicle"]}
          src={VehicleIcon}
          alt="vehicle-icon"
        />
      )}
    </div>
  );
};
export default MapVehicleMarkerIcon;
